import { render, staticRenderFns } from "./ManageTheme.vue?vue&type=template&id=4dbe2e8f"
import script from "./ManageTheme.vue?vue&type=script&lang=ts"
export * from "./ManageTheme.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports